import { useState, useEffect } from "react";
import styles from "./referralhistories.module.css";
import axios from "axios";
import { authData, withCustomerAuth } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import SideBar from "../../components/sideBar";
import { ReferralLoader } from "../../components/ContentLoader";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import TablePaginationComponent from "../../components/TablePagination";

const STATUS_META = {
  0: { label: "Pending", cls: "Pending" },
  1: { label: "Confirmed", cls: "Confirmed" },
  2: { label: "Redeemed", cls: "Redeemed" },
};

const ReferralHistories = () => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [referrals, setReferrals] = useState([]);

  const { websiteData } = useWebsite();
  useSiteBranding("Referral histories", websiteData);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/customer/referral-histories", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setContentLoading(false);
      if (response.data.status === "SUCCESS") {
        setReferrals(response?.data.data);
      }
    }).catch((error) => {
      setContentLoading(false);
    });
  }, [auth?.api_token]);

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>

              <div className={`${styles.UserHead}`}>
                <p className={styles.PageHeadEyebrow}>Rewards</p>
                <p className={`${styles.UserProName}`}>Referral histories</p>
                <p className={styles.PageHeadCount}>
                  {referrals?.length} referral{referrals?.length === 1 ? "" : "s"}
                </p>
              </div>

              {contentLoading && <ReferralLoader />}

              {!contentLoading && <div className={`${styles.BookingCard}`}>

                {referrals?.length > 0 && (
                  <div className={styles.BookingTable}>
                    <div className={styles.TableHead}>
                      <span className={styles.TableHeadCell}>Referred user</span>
                      <span className={styles.TableHeadCell}>Status</span>
                      <span className={styles.TableHeadCell}>Amount</span>
                      <span className={styles.TableHeadCell}>Used amount</span>
                    </div>

                    {referrals?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((item, index) => {
                      const meta = STATUS_META[parseInt(item?.status)];
                      return (
                        <div className={`${styles.BookingCardUnderTop}`} key={index}>
                          <div className={`${styles.MyBookConHead}`}>
                            <p className={`${styles.BookingCarDeTitle}`}>{item?.referred_user_name}</p>
                          </div>

                          {meta && <span className={styles[meta.cls]}>{meta.label}</span>}

                          <div className={`${styles.MyBookConDeSec}`}>
                            <p className={`${styles.BookingCarDeSTitle}`}>
                              <span>Amount:</span>
                              £{parseFloat(item?.amount).toFixed(2)}
                            </p>
                            <p className={`${styles.BookingCarDeSTitle}`}>
                              <span>Used Amount:</span>
                              £{parseFloat(item?.used_amount).toFixed(2)}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {referrals?.length > 0 && (<TablePaginationComponent
                  count={referrals?.length}
                  colSpan={6}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={paginationChangePage}
                  handleChangeRowsPerPage={paginationChangeRowsPerPage}
                />)}

                {referrals?.length === 0 && (<div className={`${styles.NofileSec}`}>
                  <div className={`${styles.NofileSecUnder}`}>
                    <img src="/images/no-connection.png" alt="" />
                    <p>No referrals are available now</p>
                  </div>
                </div>)}

              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default withCustomerAuth(ReferralHistories);